<template>
  <div>
    <!-- banner -->
    <div class="row">
      <div class="row banner_train pc">
        <div class="con">
          <h1>{{course.title}}</h1>
          <div class="xwz">
            <div class="col-lg-6 col-md-6 col-sm-6 text-left">
              <h2>
                专题：<span v-html="(course.venueName&&course.venueName.name) ? (
                  global.year=='2024' ? course.venueName.name.split('<br>')[0] : course.venueName.name
                ) : '敬请期待'"></span> <br>
                案例来源：<span v-if="course.lecturer" v-html="course.lecturer[0].company ? course.lecturer[0].company : '敬请期待'"></span>
              </h2>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 text-left">
              <h2 class="yy">
                会议地点：<span v-html="(course.venueName&&course.venueName.address) ? course.venueName.address : '敬请期待'"></span><br>
                分享时间：<span v-html="(course.venueName&&course.venueName.date) ? course.venueName.date : '敬请期待'"></span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="wap_banner_train mob">
        <h1>{{course.title}}</h1>
        <p>
          专题：<span v-html="(course.venueName&&course.venueName.name) ? (
            global.year=='2024' ? course.venueName.name.split('<br>')[0] : course.venueName.name
          ) : '敬请期待'"></span> <br>
          案例来源：<span v-if="course.lecturer" v-html="course.lecturer[0].company ? course.lecturer[0].company : '敬请期待'"></span><br>
          会议地点：<span v-if="(course.venueName&&course.venueName.address) ? course.venueName.address : '敬请期待'"></span><br>
          分享时间：<span v-if="(course.venueName&&course.venueName.date) ? course.venueName.date : '敬请期待'"></span>
        </p>
      </div>
    </div>
    <!-- teacher -->
    <div class="train pc">
      <div class="train_kc">
        <div class="train_person row">
          <slot v-for="(item,index) in course.lecturer">
            <a @click.prevent="$router.push({path:'/teacher',name:'Teacher',query:{sid:sid, id:item.id}})"
               class="row" :key="'lecturer'+index"
               style="width:100%;display:block;margin-top:30px;cursor:url(../../static/images/mouse2.png),auto!important;">
              <div class="le col-lg-4 col-md-4 col-sm-4">
                <div class="le_z">
                  <div class="thumbs row img-circle">
                    <img :src="item.thumbs?getSrc(item.thumbs):'../../static/images/def.jpg'" class="img-circle" width="100%"
                         style="cursor:url(../../static/images/mouse1.png),auto!important;"/>
                  </div>
                </div>
                <div class="text">
                  <span>{{item.name}}</span><br>
                  <span>{{item.company}}</span><br>
                  <span>{{item.position}}</span>
                </div>
              </div>
              <div class="ri col-lg-8 col-md-8 col-sm-8">
                <div class="row">
                  <p v-html="item.desc"></p>
                </div>
              </div>
            </a>
          </slot>
        </div>
        <div class="course_summary row">
          <div class="le">
            <img src="../../static/images/before_train/train_summary.png" />
          </div>
          <div class="ri" id="kc_gaiyao">
            <h3>课程概要</h3>
            <p v-html="course.desc"></p>
          </div>
        </div>
        <div class="course_summary row">
          <div class="le">
            <img src="../../static/images/before_train/train_shouyi.png" style="margin-top: -15px;" />
          </div>
          <div class="ri" id="kc_profit">
            <h3>听众收益</h3>
            <p v-html="course.profit"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="wap_train mob">
      <div class="wap_train_kc">
        <div class="lecturer_jieshao" id="lecturer_jieshao">
          <slot v-for="(item,index) in course.lecturer">
            <a @click.prevent="$router.push({path:'/teacher',name:'Teacher',query:{sid:sid, id:item.id}})"
               :key="'wap_lecturer'+index"
               style="margin-top:.5rem;width:100%;display:block;cursor:url('../../static/images/mouse2.png'),auto!important;">
              <div class="wap_train_person row">
                <div class="le">
                  <div class="wap_img">
                    <img :src="item.thumbs?getSrc(item.thumbs):'../../static/images/def.jpg'" width="100%"  class="img-circle"/>
                  </div>
                </div>
                <div class="ri">
                  <div class="row">
                    <h3>{{item.name}}&nbsp;&nbsp;</h3>
                  </div>
                  <div class="row">
                    <h5>{{item.company}}<br>{{item.position}}</h5>
                  </div>
                </div>
              </div>
              <div class="row">
                <p class="person_jieshao" v-html="item.desc"></p>
              </div>
            </a>
          </slot>
        </div>
        <div class="row wap_course_summary">
          <div class="row">
            <img src="../../static/images/before_train/train_dagang.png" />
            <h4>课程概要</h4>
          </div>
          <div class="row" id="wap_kc_gaiyao">
            <p v-html="course.desc"></p>
          </div>
        </div>
        <div class="row wap_course_summary">
          <div class="row">
            <img src="../../static/images/before_train/train_shouyi.png" />
            <h4>听众收益</h4>
          </div>
          <div class="row" id="wap_kc_profit">
            <p v-html="course.profit"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- courses -->
    <div class="anli row">
      <div class="all">
        <h1>本专题下其他演讲</h1>
        <ul class="row">
          <h4 v-if="!course.related || course.related==[]">敬请期待!</h4>
          <slot v-else>
            <li v-for="(item,index) in course.related" class="col-lg-4 col-md-4 col-sm-4" :key="'related'+index">
              <a @click.prevent="$router.push({path:'/course',name:'Course',query:{sid:sid, id:item.id}})"
                 :style="'border-radius:20px;background:url('+getRelatedImg(course.venueName.name)+');background-size: 100% 100%;'">
                <div class="wenzi">
                  <h2>{{item.title}}</h2><hr>
                  <h3 v-if="item.lecturer[0]" style='margin-top:25px;color:#777777'>{{item.lecturer[0].name}}</h3>
                  <p v-if="item.lecturer[0]">
                    {{item.lecturer[0].company}}<br>{{item.lecturer[0].position}}
                  </p>
                </div>
              </a>
            </li>
          </slot>
        </ul>
      </div>
    </div>
    <!-- card -->
    <!-- <Poster :_kind="'course'" :_sid="sid||global.area_id" :_dataselected="course" v-if="$route.query && $route.query.card"></Poster> -->
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable no-tabs */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import $ from 'jquery'
import wx from 'weixin-js-sdk'

export default {
  name: 'Course',
  data () {
    return {
      params: '',
      sid: '',
      course: {}
    }
  },
  methods: {
    getSrc: function (img) {
      // return img.split('?')[0] + '?imageView2/1/w/170/h/170/q/100'
      return img.split('?')[0] + '?imageView2/1/w/500/h/500/q/100'
    },
    getRelatedImg: function (n) {
      if (n === '产品创新/体验设计') {
        return '../../static/images/anli_bg01.png'
      }
      if (n === '团队管理/工程文化') {
        return '../../static/images/anli_bg02.png'
      }
      if (n === '架构设计/技术战略') {
        return '../../static/images/anli_bg03.png'
      }
      if (n === '人工智能/数据科学') {
        return '../../static/images/anli_bg04.png'
      }
      if (n === '测试管理/运维发布') {
        return '../../static/images/anli_bg05.png'
      }
      return ''
    },
    getCourse: function () {
      var area_id = ''
      if (this.sid) {
        area_id = this.sid
      } else {
        area_id = this.global.area_id
      }
      var config = this.global.config

      setSize()
      window.onresize = function () {
        setSize()
      }
      function setSize () {
        var xian = $('.train_person .thumbs img')
        var realWidth = xian.width()
        var realHeight = realWidth
        $('.train_person .thumbs  img').css({ height: realHeight })
        var xianf = $('.wap_train_person .wap_img')
        var realWidth = xianf.width()
        var realHeight = realWidth
        $('.wap_train_person .wap_img img').css({ height: realHeight })
      }

      var course_id = this.params.id || this.$route.query.cid
      var url_course = this.global.url.course_detail + area_id + '/' + course_id
      // console.log(url_course);

      this.$http
        .jsonp(url_course)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log(data);
          this.course = []
          if (data.errno && data.errno.toString() === '0') {
            this.course = data.data
            // console.log(this.course);
            let i = 0
            let jieshu = ''
            if (area_id > '2252') {
              jieshu = config[area_id].jieshu
            }
            document.title =
              data.data.title +
              ' | ' +
              data.data.lecturer[i].name +
              ' ' +
              data.data.lecturer[i].company +
              data.data.lecturer[i].position +
              ' — 第' +
              jieshu +
              '届 MPD工作坊' +
              config[area_id].title +
              '站'
            let descrit = ''
            let keywords = ''
            if (data.data.seo.length === 0) {
              descrit = document.title
              keywords = document.title
            } else {
              keywords = data.data.seo.title
            }
            $("meta[name='description']").attr('content', descrit)
            $("meta[name='keywords']").attr('content', keywords)
            let title = document.title
            let des = data.data.profit
            this.sharetitle(title, des)
          }
        })
    },
    sharetitle: function (title, des) {
      var area_id = ''
      if (this.sid) {
        area_id = this.sid
      } else {
        area_id = this.global.area_id
      }
      var config = this.global.config
      var time = Date.parse(new Date())
      var localurl = window.document.location.href
      var requesturl = this.global.url.getjssdk + '?time=' + time + '&url=' + localurl
      var appid, nonce, signature
      $.ajax({
        type: 'get',
        url: requesturl,
        dataType: 'jsonp',
        success: function (obj) {
          if (obj.errno && obj.errno.toString() === '0') {
            // console.log(obj)
            appid = obj.data.data.appid
            nonce = obj.data.data.nonce
            signature = obj.data.data.signature
            time = obj.data.data.time
            share(appid, nonce, signature, time, title, des)
          } else {
            console.log('请求错误')
          }
        }
      })
      function share (a, b, c, d, e, f) {
        wx.config({
          debug: false,
          appId: a,
          timestamp: d,
          nonceStr: b,
          signature: c,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
        })
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: e,
            desc: f,
            link: localurl,
            imgUrl: 'https://f.msup.com.cn/WechatIMG3.png', // 分享图标
            success: function () {
              console.log('成功分享')
            }
          })
          wx.onMenuShareTimeline({
            title: e, // 分享标题
            link: localurl,
            imgUrl: 'https://f.msup.com.cn/WechatIMG3.png', // 分享图标
            success: function () {
              console.log('成功分享')
            }
          })
        })
      }
    }
  },
  created () {
    this.params = this.$route.query
    this.sid = this.params.sid
    // console.log("course params  ",this.params);
    this.getCourse()
  },
  watch: {
	  '$route' (to, from) { // 监听路由是否变化
		  if (to.query.id.toString() !== from.query.id.toString()) {
		    this.params = this.$route.query
  		  this.getCourse()
		  }
	  }
 	},
  components: {
    // Poster: () => import('../components/poster/Menus.vue')
  }
}
</script>

<style scoped>
/*  */
</style>



// WEBPACK FOOTER //
// src/views/Course.vue